<template>
  <div class="card">
    <div class="card-header">{{ label }}</div>
    <div class="card-body">
      <div class="card-text col-md-12 tw-mb-2">
        <DerToggleWithLabel
          v-model="features[featureId].active"
          :label="label"
          :disabled="!center.active"
        />
      </div>
      <div class="card-text">
        <label class="col-md-12">
          <input
            v-model="features[featureId].config.reserve_number"
            type="text"
            class="form-control"
            :disabled="!features[featureId].active"
          />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import DerToggleWithLabel from "../../design-system/DerToggleWithLabel.vue";

export default {
  components: {
    DerToggleWithLabel,
  },
  props: {
    center: {},
    features: {},
    featureId: {},
    label: String,
  },
};
</script>
